/* eslint-disable */
// This file is automatically generated and should not be edited directly.
// Please edit the corresponding SVG file

import React from 'react';

const Fullscreen = (props: any) => (
<svg {...props}   viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="fullscreen">
<path id="Vector 105" d="M1 6V2C1 1.44772 1.44772 1 2 1H6" stroke="inherit" strokeWidth="inherit" strokeLinecap="round" strokeLinejoin="round"/>
<path id="Vector 107" d="M1 16V20C1 20.5523 1.44772 21 2 21H6" stroke="inherit" strokeWidth="inherit" strokeLinecap="round" strokeLinejoin="round"/>
<path id="Vector 106" d="M21 6V2C21 1.44772 20.5523 1 20 1H16" stroke="inherit" strokeWidth="inherit" strokeLinecap="round" strokeLinejoin="round"/>
<path id="Vector 108" d="M21 16V20C21 20.5523 20.5523 21 20 21H16" stroke="inherit" strokeWidth="inherit" strokeLinecap="round" strokeLinejoin="round"/>
</g>
</svg>
);

export default Fullscreen;